import { checkIsLocale, Locale } from '../../../shared';

const en = {
  head: 'Cookies',
  description:
    'We use cookies to run the service and, with your permission, to analyze usage and improve marketing performance.',
  privacyLink: 'Privacy Policy',
  cookieLink: 'Cookie Policy',
  acceptBtn: 'Accept all',
  previewBtn: 'Customize',
  necessary: 'Necessary',
  necessaryText: 'Required for the website to function (security, login, settings).',
  analytics: 'Analytics',
  analyticsText: 'Helps us understand how LocalProf is used (Google Analytics, Mixpanel).',
  adStorage: 'Marketing',
  adStorageText: 'Allows us to show more relevant ads and measure their performance.',
  personalization: 'Personalization',
  personalizationText: 'Used to tailor content and recommendations based on your preferences.',
  userData: 'Usage data',
  userDataText: 'Helps us analyze anonymized data to improve the overall service experience.',
  saveBtn: 'Allow selection',
};

const pl = {
  head: 'Cookies',
  description:
    'Używamy plików cookie, aby uruchomić usługę oraz — za Twoją zgodą — analizować korzystanie z niej i poprawiać skuteczność działań marketingowych.',
  privacyLink: 'Polityka prywatności',
  cookieLink: 'Polityka cookies',
  acceptBtn: 'Akceptuj wszystkie',
  previewBtn: 'Ustawienia',
  necessary: 'Niezbędne',
  necessaryText: 'Wymagane do działania strony (bezpieczeństwo, logowanie, ustawienia).',
  analytics: 'Analityka',
  analyticsText:
    'Pomaga nam zrozumieć, jak użytkownicy korzystają z LocalProf (Google Analytics, Mixpanel).',
  adStorage: 'Marketing',
  adStorageText: 'Umożliwia wyświetlanie bardziej trafnych reklam i mierzenie ich skuteczności.',
  personalization: 'Personalizacja',
  personalizationText:
    'Służy do dopasowywania treści i rekomendacji na podstawie Twoich preferencji.',
  userData: 'Dane o użytkowaniu',
  userDataText: 'Pomaga nam analizować zanonimizowane dane w celu ulepszenia działania usługi.',
  saveBtn: 'Zapisz wybór',
};

const translation = (locale: Locale | string) => {
  const languages = {
    en,
    pl,
  };

  return checkIsLocale(locale) ? languages?.[locale] : en;
};

export default translation;
